function ClientChecklistService(ApiService) {
  'ngInject';
  const service = {};

  service.getOrganizationTasks = function (orgId, status, page, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/tasks.json?page=${page}&status=${status}`, callbackFunc);
  };

  service.newChecklist = function (orgId, data, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/tasks.json`, { task: data }, callbackFunc);
  };

  service.deleteChecklistAndTask = function (orgId, taskId, callbackFunc) {
    ApiService.delete(`/organizations/${orgId}/tasks/${taskId}.json`, {}, callbackFunc);
  };

  service.updateChecklistAndTask = function (orgId, taskId,
     data, callbackFunc) {
    ApiService.updateSaveFile(`/organizations/${orgId}/tasks/${taskId}.json`, { task: data }, callbackFunc);
  };

  service.getChildTasks = function (orgId, parentId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/tasks/${parentId}/checklist_tasks.json`, callbackFunc);
  };

  service.newTask = function (orgId, data, callbackFunc) {
    ApiService.saveFile(`/organizations/${orgId}/tasks.json`, { task: data }, callbackFunc);
  };

  service.getTaskDetails = function (orgId, taskId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/tasks/${taskId}.json`, callbackFunc);
  };

  service.removeAttachment = function(orgId, taskId, attachmentId, callbackFunc){
    ApiService.post(`/organizations/${orgId}/tasks/${taskId}/remove_attachment/${attachmentId}.json`, { }, callbackFunc);
  };

  service.assignTaskToUser = function(orgId, taskId, assignees, callbackFunc){
    ApiService.post(`/organizations/${orgId}/tasks/${taskId}/assign_task.json`, { assignees: assignees}, callbackFunc);
  };

  service.cancelWelcome = function (callbackFunc) {
    ApiService.post(`/users/cancel_welcome`, { welcome: false }, callbackFunc);
  };

  service.completeTask = function (orgId, taskId, data, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/tasks/${taskId}/update_status.json`, {task: data}, callbackFunc);
  };

  service.addAttachment = function (orgId, taskId, data, callbackFunc) {
    ApiService.saveFile(`/organizations/${orgId}/tasks/${taskId}/add_images.json`, {files: data}, callbackFunc);
  };

  service.rearrangeTask = function (orgId, taskId, position, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/tasks/${taskId}/rearrange_task.json`, {task: {position: position}}, callbackFunc);
  };

  service.formParams = function(params, checklistId){
    if (checklistId) {
      params.parent_id = checklistId;
    }
    let nestedAttr = [];
    if(params.api_v1_task_attachments_attributes && params.api_v1_task_attachments_attributes.url){
      let add = params.api_v1_task_attachments_attributes.url;
      add.forEach(function (t) {
        nestedAttr.push({
          url: t
        });
      });
    }
    params.api_v1_task_attachments_attributes = nestedAttr;
    return params;
  };

  return service;
}
export default {
  name: 'ClientChecklistService',
  fn: ClientChecklistService
};
